import React, { useState, useEffect } from "react";
import { useAxiosPrivate } from "./../../hooks/useAxiosPrivate";
import { useNavigate } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "./../../App.css";
import { Select } from 'antd';
import { useHeader } from './../../components/HeaderContext';
import useAuth from "./../../hooks/useAuth.js";
import { useAlert } from './../../components/AlertContext.jsx';
import OkModal from "./../../components/OkModal.js";

const UsersAdd = () => {

    const baseURL = process.env.REACT_APP_API_BASE_URL;
    const axiosPrivate = useAxiosPrivate();
    const { auth } = useAuth();

    const ReturnPage = "/users";
    const Utilizador = auth.user ? auth.user : "nodejs";
    const last_modified_user_id = 1;

    const { triggerAlert } = useAlert();

    // texto do cabeçalho da pagina
    const { setHeader } = useHeader();
    useEffect(() => {
        setHeader("Add Userr");
    }, [setHeader]);

    //para guardar os valores dos campos
    const [formData, setFormData] = useState({
        company_id: '',
        user_id: '',
        username: '',
        password: '',
        confirm_password: '',
        full_name: '',
        group_id: '',
        is_active: '',
        last_modified_date: '',
        last_modified_user_id: last_modified_user_id
    })

    useEffect(() => {
        const fetchData = async () => {
            await fetchDataForSelectGroup();
        };
        fetchData();
    }, []);



    const [optionsGroup, setOptionsGroup] = useState([]);
    const fetchDataForSelectGroup = async () => {
        try {
            const response = await axiosPrivate.get(`${baseURL}/group_list`);
            const data = response.data;

            //console.log("users_add.js > fetchDataForSelectGroup > data: ", data);

            // Update options for React Select
            const selectOptions = data.map(item => ({
                value: item.group_id,
                label: item.group_name + " - " + item.description,
            }));

            setOptionsGroup(selectOptions);

        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };



    // controla de o registo foi gravado ou nao na base de dados
    const [isSubmitted, setIsSubmitted] = useState(false);

    const navigate = useNavigate();


    const [showOkModal, setShowOkModal] = useState(false);
    const [okMessage, setOkMessage] = useState("");
    const [typeOkModal, setTypeOkModal] = useState("success");

    const handleShowOkModal = (message, type) => {
        setOkMessage(message);
        setTypeOkModal(type);
        setShowOkModal(true);
    }

    const handleHideOkModal = () => {
        setShowOkModal(false);
    };


    const handleSubmitAdd = async (e) => {
        e.preventDefault();

        console.log("users_add.js > handleSubmitAdd > START");

        // valida campos cabeçalho
        if (!formData.group_id) {
            handleShowOkModal("Fields to fill in!", "warning")
            return; // Stop submission if any field is invalid
        }

        try {
            await axiosPrivate.post(`${baseURL}/users`, formData)
                .then(result => {
                    console.log(result.data);
                    // If successfully added to the database, update state to disable input fields
                    setIsSubmitted(true);

                    let message = `Record Saved!`;
                    triggerAlert(message, 'success');

                    navigate(ReturnPage);
                })
                .catch(err => {
                    if (err.response) {
                        console.log(err.response.data.err.originalError.info.message);
                        let message = `Error during saving!  \n ${err.response.data.err.originalError.info.message}`;
                        triggerAlert(message, 'error');
                    }
                    else {
                        let message = `Error during saving!`;
                        triggerAlert(message, 'error');
                    }
                })
        }
        catch (err) {
            console.error('Error adding record:', err);
            let message = `Error during saving!  \n ${err}`;
            triggerAlert(message, 'error');
        }
    }


    const handleChange_group_id = (selectedOption) => {
        if (selectedOption) {
            setFormData({ ...formData, group_id: selectedOption });
        } else {
            setFormData({ ...formData, group_id: '' }); // If the option is cleared
        }
    };


    return (
        <div className="d-flex align-items-center mt-1">
            <div className="p-2 rounded w-50">
                <form className="row g-1" onSubmit={handleSubmitAdd}>
                    <div className="col-12 interno">
                        <label className="form-label app_font1 mt-3 required" htmlFor="company_id">Company</label>
                        <input type="text" name="company_id" className="form-control form-control-sm app_font1" required disabled
                            value={formData.company_id}
                            onChange={(e) => setFormData({ ...formData, company_id: e.target.value })} />
                    </div>

                    <div className="col-12">
                        <label htmlFor="username" className="form-label mt-3 app_font1 required" >Username</label>
                        <input type="text" name="username" className="form-control form-control-sm app_font1" maxLength="30" required
                            disabled={isSubmitted}
                            value={formData.username}
                            onChange={(e) => setFormData({ ...formData, username: e.target.value })} />
                    </div>

                    <div className="col-12">
                        <label htmlFor="full_name" className="form-label mt-3 app_font1 required" >Full Name</label>
                        <input type="text" name="full_name" className="form-control form-control-sm app_font1" maxLength="100" required
                            disabled={isSubmitted}
                            value={formData.full_name}
                            onChange={(e) => setFormData({ ...formData, full_name: e.target.value })} />
                    </div>

                    <div className="col-12">
                        <label htmlFor="password" className="form-label mt-3 app_font1 required" >Password</label>
                        <input type="password" name="password" className="form-control form-control-sm app_font1" maxLength="60" required
                            disabled={isSubmitted}
                            value={formData.password}
                            onChange={(e) => setFormData({ ...formData, password: e.target.value })} />
                    </div>

                    <div className="col-12">
                        <label htmlFor="confirm_password" className="form-label mt-3 app_font1 required" >Confirm Password</label>
                        <input type="password" name="confirm_password" className="form-control form-control-sm app_font1" maxLength="60" required
                            disabled={isSubmitted}
                            value={formData.confirm_password}
                            onChange={(e) => setFormData({ ...formData, confirm_password: e.target.value })} />
                    </div>



                    <div className="col-5">
                        <label htmlFor="group_id" className="form-label app_font1 mt-2 required"> Group </label>
                        <Select
                            showSearch
                            optionFilterProp="label"
                            onChange={handleChange_group_id}
                            value={optionsGroup.find(option => option.value === formData.group_id)}
                            allowClear
                            style={{ width: '100%' }}
                            options={optionsGroup}
                            className="d-block"
                            required
                        />
                    </div>

                    <div className="col-12 interno">
                        <label className="form-label  mt-3 app_font1 required" htmlFor="last_modified_date">Data Modificão</label>
                        <input type="text" name="data_modificacao" className="form-control app_font1 form-control-sm" required disabled
                            value={formData.last_modified_date}
                            onChange={(e) => setFormData({ ...formData, last_modified_date: e.target.value })} />
                    </div>
                    <div className="col-12 interno">
                        <label className="form-label  mt-3 app_font1 required" htmlFor="last_modified_user_id">Utilizador</label>
                        <input type="text" name="last_modified_user_id" className="form-control app_font1 form-control-sm" required disabled
                            value={formData.last_modified_user_id}
                            onChange={(e) => setFormData({ ...formData, last_modified_user_id: e.target.value })} />
                    </div>
                    <div className="mt-3">
                        <button type="submit" className="btn btn-success" disabled={isSubmitted} style={{ marginRight: '20px', marginTop: '10px' }}>Save</button>
                        <button className="btn btn-outline-success" style={{ marginRight: '20px', marginTop: '10px' }} onClick={() => navigate(ReturnPage)}>Cancel</button>
                    </div>
                </form>

                <OkModal
                    showModal={showOkModal}
                    hideModal={handleHideOkModal}
                    message={okMessage}
                    type={typeOkModal}
                    header=""
                />


            </div>
        </div>
    )
}

export default UsersAdd

